import React from 'react'

const Estacionamento = ({
  width = 24,
  height = 24,
  fill = '#FFFFFF',
  ...props
}) => (
  <svg
    data-token-name="estacionamento"
    width={width}
    height={height}
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>estacionamento</title>
    <g
      id="estacionamento"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <path
        d="M10.509923,12.8574467 L10.509923,15.4263281 L14.6845911,15.4263281 C15.2166043,15.4263281 15.6480003,15.8602396 15.6480003,16.3916239 C15.6480003,16.9230081 15.2166043,17.3537753 14.6845911,17.3537753 L9.54682829,17.3537753 C9.01450071,17.3537753 8.58341914,16.9230081 8.58341914,16.3916239 L8.58341914,7.39896671 C8.58341914,6.86758243 9.01450071,6.43681529 9.54682829,6.43681529 L14.6845911,6.43681529 C15.2166043,6.43681529 15.6480003,6.86758243 15.6480003,7.39896671 C15.6480003,7.930351 15.2166043,8.36426243 14.6845911,8.36426243 L10.509923,8.36426243 L10.509923,10.9331439 L14.6845911,10.9331439 C15.2166043,10.9331439 15.6480003,11.363911 15.6480003,11.8952953 C15.6480003,12.4266796 15.2166043,12.8574467 14.6845911,12.8574467 L10.509923,12.8574467 Z M2.54041643,10.3105753 C2.45709286,10.3105753 2.37251157,10.2979981 2.28855914,10.2759881 C1.77478286,10.1376396 1.47073043,9.60939957 1.60970786,9.09373671 C2.220957,6.829851 3.58369043,4.78606529 5.44636529,3.33969386 C6.38021814,2.61336386 7.417518,2.05053671 8.52965186,1.66064529 C9.68046043,1.261321 10.8866084,1.05694243 12.1157097,1.05694243 C13.34261,1.05694243 14.5475003,1.25817671 15.6961079,1.66064529 C16.806984,2.04739243 17.8430261,2.61021957 18.7762501,3.33340529 C19.6997269,4.04715814 20.498061,4.90240386 21.1498714,5.87084386 C21.812058,6.85500529 22.305082,7.93349529 22.6157374,9.074871 C22.7556581,9.58738957 22.4528634,10.1156296 21.9394016,10.2571224 C21.4259397,10.395471 20.896442,10.0936196 20.7568357,9.57795671 C20.2509201,7.71968386 19.1280957,6.04377957 17.5961997,4.85523957 C16.0155673,3.63211243 14.1205063,2.98438957 12.1157097,2.98438957 C10.1074544,2.98438957 8.209878,3.63211243 6.62830229,4.86152814 C5.09451971,6.05321243 3.97263857,7.73540529 3.46986729,9.59682243 C3.35352871,10.0275896 2.964895,10.3105753 2.54041643,10.3105753 Z M12.1157097,22.8185439 C7.17226371,22.8185439 2.84415443,19.485601 1.59021329,14.709431 C1.455009,14.1937681 1.76283457,13.6686724 2.27755414,13.5334681 C2.79195929,13.3982639 3.31862714,13.7064039 3.45383143,14.2189224 C4.485786,18.1492796 8.04763286,20.894241 12.1157097,20.894241 C16.1837866,20.894241 19.7456334,18.1492796 20.777588,14.2189224 C20.9124779,13.7064039 21.4394601,13.3982639 21.9538653,13.5334681 C22.4685849,13.6686724 22.776096,14.1937681 22.6412061,14.709431 C21.3869506,19.485601 17.0588413,22.8185439 12.1157097,22.8185439 Z"
        id="Fill-4"
        fill={fill}
      />
    </g>
  </svg>
)

export default Estacionamento
